export default __webpack_public_path__ + "static/media/phoneForwardedTeal.7cc0cf1d.svg";